export const phoneRegex = /^(\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}$/;

export const specialCharacterRegex = /^[a-zA-Z0-9\s]+$/;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const urlRegex =
  /^(https?:\/\/)?(?:www\.)?(?:[A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}(?::\d{2,5})?(?:\/[^\s]*)?$/;

export const numberSymbolsRegex = /[$%,]/g;
